import {
  CallWithTranscript,
  ErrorText,
  LoadingIndicator,
} from "@/components";

import { useGetVoiceAIOutreachSignedAudioUrl } from "@/hooks/queries/useGetVoiceAIOutreachSignedAudioUrl";
import { VoiceAIOutreachTranscript } from "@/types";

export const VoiceAICallWithTranscript = ({
  audioRef,
  candidacyId,
  candidateFirstName,
  candidateLastName,
  jobTitle,
  transcript,
  voiceAIOutreachId,
}: {
  audioRef: React.RefObject<HTMLAudioElement>;
  candidacyId: string;
  candidateFirstName: string;
  candidateLastName: string;
  jobTitle: string;
  transcript: VoiceAIOutreachTranscript;
  voiceAIOutreachId: string;
}) => {
  /* Database CRUD Operations */
  // Read
  const audioQuery = useGetVoiceAIOutreachSignedAudioUrl({
    currentCandidacyId: candidacyId,
    voiceAIOutreachId,
  });

  /* Render */
  const render = () => {
    if (audioQuery.isPending) return <LoadingIndicator variant="medium" />;
    if (audioQuery.isError) {
      return <ErrorText errorMessage="Error retrieving call audio." />;
    }

    return (
      <CallWithTranscript
        audioRef={audioRef}
        audioSrc={audioQuery.data}
        downloadFilename={`voice-ai-call-${candidateFirstName}-${candidateLastName}-${jobTitle}.mp3`
          .toLowerCase()
          .replace(/\s+/g, "-")}
        getRoleLabel={(role) =>
          role === "agent" ? "Stevie" : candidateFirstName
        }
        transcriptLines={transcript.transcriptLines}
      />
    );
  };

  return render();
};
